/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
class n extends r.Component {
  shouldComponentUpdate(e) {
    return e.shouldUpdateOnDrag || !e.isDragging;
  }
  render() {
    return this.props.children;
  }
}
export {
  n as MiddleLayerOptimization
};
